import Modal from "react-modal";
import "../../assets/css/tutor_policy.css";
import { X } from "lucide-react";

Modal.setAppElement("#root");

const PrivacyPolicyModal = ({
  showPolicyModal,
  setShowPolicyModal,
  handleAgree,
  handleCancel,
}) => {
  return (
    <Modal
      isOpen={showPolicyModal}
      onRequestClose={handleCancel}
      contentLabel="Privacy Policy"
      style={{
        overlay: { backgroundColor: "rgba(0, 0, 0, 0.6)" },
        content: {
          maxWidth: "60%",
          maxHeight: "80vh",
          margin: "auto",
          padding: "20px",
          borderRadius: "12px",
          textAlign: "left",
          overflowY: "auto",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
          border: "none",
          background: "#fff",
        },
      }}
    >
      <div className="modal-header">
        <h2>Privacy Policy For Tutor</h2>
        <button
          className="modal-close-button"
          onClick={() => setShowPolicyModal(false)}
        >
          <X size={20} />
        </button>
      </div>
      <div className="modal-content">
        <p>
          <strong>1. Introduction</strong>
          <br />
          MathSpeedUp is committed to protecting your privacy. This Privacy
          Policy explains how we collect, use, disclose, and safeguard your
          information when you choose to make your tutor profile public.
        </p>
        <p>
          <strong>2. Information Collected</strong>
          <br />
          When you mark your tutor profile as public, the following information
          may be displayed to all users:
        </p>
        <ul>
          <li>Name</li>
          <li>Profile Picture</li>
          <li>Subjects</li>
          <li>Skills</li>
          <li>Teaching Location (Home, Center, Online, Offline)</li>
          <li>Cities Where You Can Teach</li>
          <li>Experience </li>
          <li>Pricing Structure</li>
          <li>Social Media Links (if provided)</li>
          <li>Any Additional Public Information You Provide</li>
        </ul>

        <p>
          <strong>3. Information Not Publicly Shared</strong>
          <br />
          The following personal information remains private and is not shared
          publicly:
        </p>
        <ul>
          <li>Email Address</li>
          <li>Phone Number</li>
          <li>Secure Login Credentials</li>
        </ul>
        <p>
          <strong>4. How We Use Your Information</strong>
          <br />
          Your public profile is used to help students and parents find suitable
          tutors based on their requirements. By making your profile public, you
          consent to:
        </p>
        <ul>
          <li>Displaying the listed public information to all users.</li>
          <li>Allowing users to contact you through our platform.</li>
          <li>
            Being searchable based on subjects, class, location, and other
            criteria.
          </li>
        </ul>
        <p>
          <strong>5. Third-Party Sharing</strong>
          <br />
          We do not sell or share your personal data with third parties for
          marketing purposes. However, your public profile may be visible on
          search engines or through direct sharing of your profile link.
        </p>
        <p>
          <strong>6. Your Rights and Control</strong>
          <br />
          You can update or revoke your public profile status at any time by
          changing your profile settings. Once made private, your profile will
          no longer be visible to other users.
        </p>
        <p>
          <strong>7. Security Measures</strong>
          <br />
          We take reasonable precautions to protect your personal information
          from unauthorized access, disclosure, or misuse. However, publicly
          shared information may be accessed by anyone, so please share
          responsibly.
        </p>
        <p>
          <strong>8. Contact Us</strong>
          <br />
          If you have any questions or concerns about this Privacy Policy,
          please contact us at [email address].
        </p>
        <p>
          <strong>9. Changes to This Policy</strong>
          <br />
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated effective date.
        </p>
        <p>
          By choosing to make your tutor profile public, you acknowledge that
          you have read and understood this Privacy Policy and agree to its
          terms.
        </p>
      </div>
      <div className="modal-footer">
        <button onClick={handleAgree} className="agree-button">
          Agree
        </button>
        <button onClick={handleCancel} className="cancel-button">
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default PrivacyPolicyModal;
